<template>
  <SuggestedListingProperty
    v-if="property"
    :listing="listing"
    :property="property"
  />
  <div v-else class="d-flex flex-row align-items-center gap-3">
    <spinner-view small />
    Loading property {{ propertyId }}
  </div>
</template>

<script>
import SuggestedListingProperty from "@/components/SuggestedListingProperty.vue";
import {Listing} from "@/models/Listing";
import SpinnerView from "@/components/common/SpinnerView.vue";
import {PropertyDetails} from "@/models/PropertyDetails";
export default {
  components: {SpinnerView, SuggestedListingProperty},
  props: {
    listing: Listing,
    propertyId: String
  },
  data() {
    return {
      property: null
    };
  },
  watch: {
    propertyId: {
      immediate: true,
      async handler() {
        this.property = await PropertyDetails.one(this.listing.city, this.propertyId);
      }
    }
  }
}
</script>
